import React, { useEffect } from 'react';
import {
  MenuItem,
  Grid,
  ButtonGroup,
  Button,
  Popper,
  Grow,
  ClickAwayListener,
  Paper,
  GridList
} from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  // root: {
  //   display: 'flex',
  //   flexWrap: 'wrap',
  //   justifyContent: 'space-around',
  //   overflow: 'hidden',
  //   backgroundColor: theme.palette.background.paper
  // },
  versionsList: {
    width: 200,
    height: 150,
    padding: 20
  },
  booksList: {
    width: 350,
    height: 275,
    padding: 20
  },
  chaptersList: {
    width: 330,
    height: 100,
    padding: 20
  }
}));

function MultiColumnsSelection({ data, onSelect, id, cols, defaultValue }) {
  // console.log('index pass in: ', data, defaultValue);
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const [selectedIndex, setSelectedIndex] = React.useState(defaultValue);

  useEffect(
    () => {
      setSelectedIndex(defaultValue);
    },
    [defaultValue]
  );
  const handleMenuItemClick = (event, index) => {
    onSelect(index);
    setSelectedIndex(index);
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen);
  };

  const handleClose = event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };
  const classes = useStyles();

  let cssClass;
  if (id === 'versionsList') {
    cssClass = classes.versionsList;
  } else if (id === 'booksList') {
    cssClass = classes.booksList;
  } else {
    cssClass = classes.chaptersList;
  }
  // const handleClick = () => {
  //   console.info(`You clicked`);
  // };

  return (
    <div>
      <Grid container direction="column">
        <Grid item xs={12}>
          <ButtonGroup
            variant="contained"
            color="primary"
            ref={anchorRef}
            aria-label="split button"
          >
            {/* <Button onClick={handleClick}>{booksData.bible[selectedIndex].name}</Button> */}
            <Button>
              {(data && (data[selectedIndex] && data[selectedIndex].name)) ||
                (data && data[0].name)}
            </Button>
            <Button
              color="primary"
              size="small"
              aria-controls={open ? 'split-button-menu' : undefined}
              aria-expanded={open ? 'true' : undefined}
              aria-label="select merge strategy"
              aria-haspopup="menu"
              onClick={handleToggle}
            >
              <ArrowDropDownIcon />
            </Button>
          </ButtonGroup>
          <Popper
            open={open}
            anchorEl={anchorRef.current}
            transition
            disablePortal
            style={{ zIndex: 6 }}
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'
                }}
              >
                <Paper>
                  <ClickAwayListener onClickAway={handleClose}>
                    <GridList id={id} cols={cols} cellHeight={20} spacing={1} className={cssClass}>
                      {data.map((option, index) => (
                        <MenuItem
                          key={option.id}
                          // disabled={index === 2}
                          selected={index === selectedIndex}
                          onClick={event => handleMenuItemClick(event, index)}
                        >
                          {option.name}
                        </MenuItem>
                      ))}
                    </GridList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </Grid>
      </Grid>
    </div>
  );
}
export default MultiColumnsSelection;
